import styled, { css } from 'styled-components';

export const LogoArea = styled.div<{ left?: string }>`
  position: absolute;
  height: 50px;
  left: ${props => props.left || '0'};
  top: 0;
  background-color: var(--background);
  z-index: 2;
  img {
    height: 60%;
    margin-top: 20px;
    margin-left: 38px;
  }
`;

export const Circle = styled.div<{ isSelected?: boolean }>`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #03041966;
  z-index: 1;
  border: 1px solid var(--border);
  ${props =>
    props.isSelected &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      background-color: var(--primary);
    `}
`;

export const ActionsWrapper = styled.div<{
  isVisible: boolean;
}>`
  display: ${props => (props.isVisible ? 'flex' : 'none')};
  position: absolute;
  top: 20px;
  right: 0;
  z-index: 1;
  flex-direction: column;

  background: var(--background);
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 12px;
`;

export const ActionButton = styled.div`
  cursor: pointer;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  gap: 10px;
  align-items: center;
  span {
    white-space: nowrap;
  }
  .icon {
    margin-left: auto;
    display: flex;
  }
  &:not(:first-child) {
    border-top: 1px solid var(--border);
  }
  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  color: var(--text-secondary);
  &:hover {
    background-color: var(--primary);
    color: var(--background);
  }
`;

export const ActionWrapperRow = styled(ActionButton)`
  display: flex;
  gap: 25px;
  justify-content: space-between;
`;

export const ShareModalDropdown = styled.div<{
  top: number;
  left?: number;
  isBottom: boolean;
  isLeft?: boolean;
}>`
  position: fixed;
  background-color: var(--background);
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  z-index: 1000;
`;

export const ShareModalDropdownItem = styled.button`
  color: var(--text-secondary);
  font-size: 12px;
  line-height: 14.52px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  outline: none;
  border: none;
  cursor: pointer;
  padding: 20px 16px 20px 16px;

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--border);
    padding-bottom: 20px;
  }
`;

export const ShareModalAnimate = styled.div<{ color?: string }>`
  border: 2px solid var(--border);
  border-radius: 50%;
  border-top: 2px solid ${props => props.color || 'var(--primary)'};
  border-left: 2px solid ${props => props.color || 'var(--primary)'};
  border-right: 2px solid ${props => props.color || 'var(--primary)'};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spinner 1s linear infinite;

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const numericalInputStyles = `
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
  height: 32px;
  padding: 0 8px;
  margin: 0;
  width: calc(100% - 16px);
  font-size: 14px;
  line-height: 16.94px;
  font-weight: 400;

  /*
   * Bordered-field-primitive hover/focus standard — see
   * docs/design-system.md "Form Fields (Bordered Primitives)".
   * Single channel: border-color escalates on hover and focus, no
   * outline halo.
   */
  outline: none;
  transition: border-color var(--transition-fast);
  &:hover {
    border-color: var(--text-muted);
  }
  &:focus-visible {
    border-color: var(--accent);
  }
`;
